import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

// Needs variant pack groups, which the lazy queries key on, and the expanded
// action, which is the only action the lazy path fetches items with
export const useCatalogLazyCarouselsEnabled = () => {
  const itemGroupsEnabled = useDynamicConfigValue('item_groups_enabled');
  const lazyCarouselsEnabled = useDynamicConfigValue(
    'catalog_lazy_carousels_enabled',
  );
  const expandedEnabled = useDynamicConfigValue(
    'catalog_group_items_expanded_enabled',
  );

  return Boolean(itemGroupsEnabled && lazyCarouselsEnabled && expandedEnabled);
};
